NtechApp.TeamNotifications = function($view) { 
    var me = this;

    this._$view = null;

    this._click = null;
    this._ajax = null;
    this._loader = null;
    this._overlay = null;

    this._viewMessageForm = null;

    this._construct = function() {
        me._$view = $view;

        me._click = new NtechApp.TouchClickEvent();
        me._ajax = new NtechApp.Ajax();
        me._loader = new NtechApp.Loader();
        me._overlay = new NtechApp.Overlay();

        me._viewMessageForm = new NtechApp.ModalForm();

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen(me._$view, "[data-rmMessageModel]", function(event) {
            event.preventDefault();

            var $button = $(event.target).closest("[data-rmMessageModel]");
            var modelId = $button.closest("[data-modelId]").attr("data-modelId");

            me._rmMessageNotification.call(me, modelId, $button);

            return false;
        });

        me._click.listen(me._$view, "[data-viewMessage]", function(event) {
            event.preventDefault();

            var $button = $(event.target).closest("[data-viewMessage]");
            var modelId = $button.closest("[data-modelId]").attr("data-modelId");

            me._viewMessageNotification.call(me, modelId, $button);

            return false;
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.TeamNotifications, {
    _enableLoader: function() {
        this._loader.on();
        this._overlay.on();
    },

    _disableLoader: function() {
        this._loader.off();
        this._overlay.off();
    },

    _rmMessageNotification: function(modelId, $button) {
        var me = this;
        //this._enableLoader();
        
        NtechApp.confirmForm.load(function() {
            me._ajax.post({
                url: Routing.generate("business_dashboard_delete_teammessage"),
                data: {modelId: modelId},
                onSuccess: function (data) {
                    $button.closest("[data-modelId]").remove();

                    var $count = $("body").find("[data-updatesCount]");
                    var val = parseInt($count.text(), 10);
                    val--;
                    if(val < 0) val = 0;
                    $count.text(val);

                    NtechApp.info.on("Message successfully removed.", 3500);
                    NtechApp.confirmForm.unload();
                },
                onComplete: function () {
                    //me._disableLoader();
                }
            });
        });
    },

    _getViewMessageFormRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_dashboard_view_teammessage';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_dashboard_view_teammessage';
    },

    _viewMessageNotification: function(modelId, $button) {
        var me = this;

        this._viewMessageForm.load(this._getViewMessageFormRoute(), {modelId: modelId}, function($form) {
            me._click.listen($form.find("[data-closeBut]"), function(e) {
                me._viewMessageForm.unload();
            });
        });
    },

    rmNotificationById: function(modelId) {
        this._$view.find("[data-modelId='" + modelId + "']").remove();
    }
});